import React, { useState } from 'react'
import dynamic from 'next/dynamic'
import { Nav } from 'react-bootstrap'
import PropTypes from 'prop-types'

import navStyles from '@shared/components/commonNav/style.module.scss'
import mobilefilter from '@assets/scss/components/mobile-filter.module.scss'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import CustomLink from '../customLink'
import usePolling from '@shared/hooks/usePolling'
import { CURRENT_MATCHES } from '@graphql/fixtures/fixtures.query'
import { getTimeZone, parallelCalls } from '@shared-submodule/utils'
import queryGraphql from '../queryGraphql'

const FixtureData = dynamic(() => import('@shared/components/fixtureContent/fixtureData'))
const NoData = dynamic(() => import('@shared/components/noData'), { ssr: false })
function CurrentMatches({ data, status, filterData }) {
  const [currentMatchesData, setCurrentMatchesData] = useState(data)

  async function pollingCallback() {
    try {
      const [international, league, domestic] = await parallelCalls([
        queryGraphql(CURRENT_MATCHES, { input: { eCategory: 'i', eStatus: 'l', sTimezone: getTimeZone(), nSkip: 1, nLimit: 50 } }),
        queryGraphql(CURRENT_MATCHES, { input: { eCategory: 'l', eStatus: 'l', sTimezone: getTimeZone(), nSkip: 1, nLimit: 50 } }),
        queryGraphql(CURRENT_MATCHES, { input: { eCategory: 'd', eStatus: 'l', sTimezone: getTimeZone(), nSkip: 1, nLimit: 50 } })
      ])
      return { international, league, domestic }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  usePolling(async () => {
    const data = await pollingCallback()
    setCurrentMatchesData(data)
  }, { deps: [status], skip: status !== 'l' })

  return (
    <div className="position-relative">
      <div
        className={`d-flex flex-column flex-sm-row align-items-start justify-content-between mt-3 mb-2 ${mobilefilter.fixturesTab} ${mobilefilter.lightTab}`}>
        <Nav className={`${navStyles.pillsNav} ${navStyles.commonNav} ${navStyles.marginNav}`}>
          <Nav.Item className={`${navStyles.item}`}>
            <CustomLink href={allRoutes.fixturesNew} prefetch={false}>
              <a className={`${status === 'l' && navStyles.active} nav-link`}>
                Live
              </a>
            </CustomLink>
          </Nav.Item>
          <Nav.Item className={`${navStyles.item}`}>
            <CustomLink href={allRoutes.fixturesUpcomingNew} prefetch={false}>
              <a className={`${status === 'u' && navStyles.active} nav-link`}>
                Upcoming
              </a>
            </CustomLink>
          </Nav.Item>
          <Nav.Item className={`${navStyles.item}`}>
            <CustomLink href={allRoutes.fixturesRecentNew} prefetch={false}>
              <a className={`${status === 'r' && navStyles.active} nav-link`}>
                Recent
              </a>
            </CustomLink>
          </Nav.Item>
        </Nav>
      </div>
      {currentMatchesData?.international?.listAllFixtures?.length === 0 &&
      currentMatchesData?.league?.listAllFixtures?.length === 0 &&
      currentMatchesData?.domestic?.listAllFixtures?.length === 0 ? (
        <NoData />
          ) : (
        <>
          {currentMatchesData?.international?.listAllFixtures?.length ? (
            <>
              <h3 className='small-head'>
                International
              </h3>
              <FixtureData data={currentMatchesData?.international?.listAllFixtures} isSeriesShow />
            </>
          ) : null}
          {currentMatchesData?.league?.listAllFixtures?.length ? (
            <>
              <h3 className='small-head'>
                League
              </h3>
              <FixtureData data={currentMatchesData?.league?.listAllFixtures} isSeriesShow />
            </>
          ) : null}
          {currentMatchesData?.domestic?.listAllFixtures?.length ? (
            <>
              <h3 className='small-head'>
                Domestic
              </h3>
              <FixtureData data={currentMatchesData?.domestic?.listAllFixtures} isSeriesShow />
            </>
          ) : null}
        </>
          )}
    </div>
  )
}
CurrentMatches.propTypes = {
  data: PropTypes.object,
  status: PropTypes.string,
  open: PropTypes.bool,
  toggleFilter: PropTypes.bool,
  handleFilter: PropTypes.func,
  filterData: PropTypes.object
}
export default CurrentMatches
